// extracted by mini-css-extract-plugin
export default {"loginFormWrapper":"LoginForm_loginFormWrapper__8THRD","loginFormErrors":"LoginForm_loginFormErrors__LRJC4"};